<template>
  <v-app>
    <v-toolbar clipped-right clipped-left color="white">
      <v-toolbar-side-icon color="orange" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <span style="color:orange;">{{Name}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="home" v-on="on" flat>
              <v-icon dark color="orange">home</v-icon>
            </v-btn>
          </template>
          <span style="color:white">Homepage</span>
        </v-tooltip>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="files" v-on="on" flat>
              <v-icon dark color="orange">list</v-icon>
            </v-btn>
          </template>
          <span style="color:white">Files</span>
        </v-tooltip>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="signout" v-on="on" flat>
              <v-icon dark color="orange">meeting_room</v-icon>
            </v-btn>
          </template>
          <span style="color:white">Sign Out</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant="mini"
      style="color:orange;"
      absolute
      temporary
    >
      <v-list class="pa-1">
        <v-list-tile v-if="mini" @click.stop="mini = !mini">
          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar tag="div">
          <v-list-tile-avatar>
            <v-avatar v-if="userPhoto">
              <v-dialog max-width="500px">
                <template v-slot:activator="{ on }">
                  <img :src="userPhoto" v-on="on" />
                </template>
                <v-card hover>
                  <v-container grid-list-md>
                    <v-layout row>
                      <v-flex xs12 sm6 md4 reverse>
                        <v-img :src="userPhoto"></v-img>
                      </v-flex>
                      <v-layout column justify-center align-center>
                        <h1>
                          <v-icon>arrow_drop_down</v-icon>Photo URL
                          <v-icon>arrow_drop_down</v-icon>
                        </h1>
                        <h3>{{userPhoto}}</h3>
                        <h5>[ Size : 200x300 px ]</h5>
                      </v-layout>
                    </v-layout>
                  </v-container>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="orange" flat @click="drawer = !drawer">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-avatar>
            <v-avatar v-else>
              <v-icon>person</v-icon>
            </v-avatar> 
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-text-field v-model="Name" :value="Name" @change="chgname" color="orange"></v-text-field>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.stop="mini = !mini">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider light></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon color="orange">lock</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-dialog max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Change Password</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <span class="headline" style="color:orange">Change {{ Name }} Password</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap column>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        type="password"
                        label="Current Password"
                        v-model="password.old"
                        color="orange"
                      ></v-text-field>
                      <v-text-field
                        type="password"
                        label="New Password"
                        v-model="password.new"
                        color="orange"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" flat @click="chgpw">Change</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon color="orange">photo_library</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-dialog max-width="500px">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on" style="color:orange">Photo Profile</v-list-tile-title>
              </template>
              <v-card hover>
                <v-card-title>
                  <span class="headline">Pick Preferred Image</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap column>
                    <v-flex xs12 sm6 md4>
                      <v-avatar v-for="(p,i) in photos" :key="i">
                        <img :src="p" @click="chgphoto(p)" />
                      </v-avatar>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="orange" flat @click="drawer = !drawer">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-parallax
      src="https://firebasestorage.googleapis.com/v0/b/artuseum-75.appspot.com/o/izzatzr%2F8.jpg?alt=media&token=f12c9377-7709-4e6d-8dec-a5b8bd9523e6"
      height="100%"
      style="width: 100%; height: 100%; position: relative; "
    >
      <v-hover>
        <v-container>
          <v-layout justify-center>
            <span class="headline" style="font-weight:bold">Score Board</span>
          </v-layout>
          <v-divider></v-divider>
          <v-card>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              color="orange"
              single-line
              flat
              box
              hide-details
            ></v-text-field>
            <v-data-table :headers="headers" :items="table" class="elevation-10" :search="search">
              <template v-slot:items="props">
                <td class="text-xs-left">
                  <v-avatar size="30">
                    <img :src="props.item.photo" />
                  </v-avatar>
                  {{ props.item.username }}
                </td>
                <td class="text-xs-center">{{props.item.date}}</td>
                <td class="text-xs-center">{{props.item.pretest}}</td>
                <td class="text-xs-center">{{props.item.posttest}}</td>
                <td class="text-xs-right">{{props.item.status}}</td>

                <td class="justify-center layout px-0"></td>
              </template>
              <v-layout align-center justify-center></v-layout>
            </v-data-table>
          </v-card>
        </v-container>
      </v-hover>
    </v-parallax>
  </v-app>
</template>

<script>
import firebase from "firebase";
import router from "@/router";

const _auth = firebase.auth();
const _db = firebase.firestore();
const _scoredb = _db.collection("scores");

export default {
  data() {
    return {
      search: "",
      userPhoto: "",
      photos: [],
      icon: "",
      mini: false,
      password: { new: "", old: "" },
      drawer: false,
      Name: "",
      headers: [
        { text: "Nama", value: "username", sortable: true, align: "center" },
        {
          text: "Date",
          value: "date",
          sortable: true,
          align: "center"
        },
        {
          text: "Pre-test",
          value: "pretest",
          sortable: true,
          align: "center"
        },
        {
          text: "Post-test",
          value: "posttest",
          sortable: true,
          align: "center"
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
          align: "right"
        }
      ],
      type: "",
      table: []
    };
  },
  methods: {
    chgphoto: function(v) {
      this.userPhoto = v;
      _auth.currentUser.updateProfile({ photoURL: v }).catch(er => {
        alert(er);
      });
    },
    chgname: function() {
      firebase
        .auth()
        .currentUser.updateProfile({ displayName: this.Name })
        .catch(e => alert(e));
    },
    chgpw: function() {
      _auth.currentUser
        .reauthenticateWithCredential(
          firebase.auth.EmailAuthProvider.credential(
            _auth.currentUser.email,
            this.password.old
          )
        )
        .then(
          _auth.currentUser
            .updatePassword(this.password.new)
            .then(e => alert("password updated succesfully ", e))
            .catch(r => alert(r))
        );
    },
    signout: function() {
      _auth.signOut().then(router.push("/"));
    },
    about: function() {
      router.push("/about");
    },
    home: function() {
      router.push("/");
    },
    files: function() {
      router.push("/files");
    }
  },
  // beforeCreate() {
  //   // if (!_auth.currentUser) router.push("/");
  // },
  mounted() {
    var temp;

    _scoredb.where("uid", "==", _auth.currentUser.uid).onSnapshot(d => {
      d.docs.map(mp => {
        _scoredb.where("type", "==", mp.data().type).onSnapshot(e => {
          temp = e.docs.map(snap => {
            return snap.data();
          });
          this.table = temp;
          temp = [];
        });
      });
    });

    for (let i = 0; i <= 107; i++) {
      const rand = Math.floor(Math.random() * 999);
      this.photos.push("https://picsum.photos/id/" + rand + "/200/300");
    }
    this.Name = _auth.currentUser.displayName;
    this.userPhoto = _auth.currentUser.photoURL;
  }
};
</script>

